import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCommonService } from '@shared/services/http-common.service';
import { GenericHttpResponse } from '@shared/services/interfaces/generic-http-response.interface';
import { Inicio } from './inicio.interface';

@Injectable({
  providedIn: 'root'
})
export class InicioService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(): Observable<GenericHttpResponse<Inicio>> {
    return this.http.get<GenericHttpResponse<Inicio>>(
      this.httpCommonService.makeUrl('/inicio'),
      { headers: this.httpCommonService.getHeader() }
    );
  }
}
